import { FC } from 'react';
import styled from 'styled-components';

const ViewSwitcher = styled.div`
  display: flex;
  gap: 2px;
  background: #F3F4F6;
  border-radius: 7px;
  padding: 2px;
`;

const ViewButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 24px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background: ${({ $active, theme }) => ($active ? theme.palette.white : 'transparent')};
  color: ${({ $active }) => ($active ? '#1F2937' : '#6B7280')};
  box-shadow: ${({ $active }) => ($active ? '0 1px 3px rgba(0,0,0,0.10)' : 'none')};
  transition: all 0.15s;

  &:hover {
    color: #1F2937;
  }
`;

interface ViewModeSwitcherProps {
  viewMode: 'grid' | 'list';
  onChange: (mode: 'grid' | 'list') => void;
}

export const ViewModeSwitcher: FC<ViewModeSwitcherProps> = ({ viewMode, onChange }) => (
  <ViewSwitcher>
    <ViewButton $active={viewMode === 'grid'} onClick={() => onChange('grid')} title="Grid view">
      <svg width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
        <rect x="1" y="1" width="6" height="6" rx="1" />
        <rect x="9" y="1" width="6" height="6" rx="1" />
        <rect x="1" y="9" width="6" height="6" rx="1" />
        <rect x="9" y="9" width="6" height="6" rx="1" />
      </svg>
    </ViewButton>
    <ViewButton $active={viewMode === 'list'} onClick={() => onChange('list')} title="List view">
      <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 16 16">
        <line x1="1" y1="4" x2="15" y2="4" />
        <line x1="1" y1="8" x2="15" y2="8" />
        <line x1="1" y1="12" x2="15" y2="12" />
      </svg>
    </ViewButton>
  </ViewSwitcher>
);
